// extracted by mini-css-extract-plugin
module.exports = {"parent":"NewLoading_parent__3U2Aj","loader":"NewLoading_loader__4pOwa"};